import { useCallback, useEffect, useRef, useState } from 'react';
import { ConfigurationAPI } from '../apis/ConfigurationAPI';
// Module-level cache and dedup for platform host
let cachedPlatformHost = null;
let ongoingPlatformHostRequest = null;
// Hook to get platform host with in-memory caching
export const usePlatformHost = () => {
    const [localCached, setLocalCached] = useState(cachedPlatformHost);
    const localCachedRef = useRef(localCached);
    useEffect(() => {
        localCachedRef.current = localCached;
    }, [localCached]);
    const getPlatformHost = useCallback(async () => {
        if (localCachedRef.current !== null)
            return localCachedRef.current;
        if (cachedPlatformHost !== null) {
            setLocalCached(cachedPlatformHost);
            return cachedPlatformHost;
        }
        if (ongoingPlatformHostRequest)
            return ongoingPlatformHostRequest;
        const requestPromise = (async () => {
            try {
                const host = await ConfigurationAPI.getPlatformHost();
                cachedPlatformHost = host;
                setLocalCached(host);
                return host;
            }
            catch {
                ongoingPlatformHostRequest = null;
                return '';
            }
            finally {
                ongoingPlatformHostRequest = null;
            }
        })();
        ongoingPlatformHostRequest = requestPromise;
        return requestPromise;
    }, []);
    return getPlatformHost;
};
